import { localTime, localTimeZone } from "./time.ts";

/** A time in the browser's local time, with the ISO time it was given (UTC) on hover. */
export function LocalTime({ iso }: { iso: string }) {
  return (
    <time dateTime={iso} title={iso}>
      {localTime(iso)}
    </time>
  );
}

/** Says which time zone a page's times are in. */
export function TimeZoneNote() {
  return <p className="text-muted">Times are local, in {localTimeZone()}.</p>;
}
